module.exports = "<div fxLayout=\"row\" fxLayoutAlign=\"center center\" class=\"loading-indicator\" *ngIf=\"isLoading\">\r\n  <mat-spinner aria-label=\"Loading...\"  [diameter]=\"diameter\"></mat-spinner>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pillar/common/components/action-loading.component.html
// module id = ./src/app/pillar/common/components/action-loading.component.html
// module chunks = main